import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { QuestionnaireData, StepData } from "src/app/models/QuestionnaireData.model";
import { NumberInput } from "@angular/cdk/coercion";
import { environment } from 'src/environment';
import { saveAs } from 'file-saver';
import { DatePipe } from "@angular/common";
import { Recipient } from "src/app/models/recipients.model";
import { QuestionnaireDataByQuestion } from "src/app/models/QuestionnaireDataByQuestions.model";
import { TostesStore } from "src/app/store/tostes-store";
import { TostTypeEnum } from "src/app/shared/models/tostes.model";
import { getNowDateToString } from "src/app/services/answers-api.service";
import { ApiExposureData } from "src/app/models/apiExposureData.model";

@Injectable({ providedIn: 'root' })
export class DataSummaryApiService {
    #httpservice = inject(HttpClient);
    #datePipe = inject(DatePipe);
    #tostesStore = inject(TostesStore);
    // #baseUrl = environment.apiUrl;;
    #specificUrl = `${environment.apiUrl}/dataSummary`;

    getQuestionnaireDataSummary = (id: number, numPage: number | null) =>
        this.#httpservice.post<QuestionnaireDataByQuestion>(`${this.#specificUrl}/getDataSummary`, { id, numPage: numPage });

    getApiExposureData = (id: number) =>
        this.#httpservice.get<ApiExposureData>(`${this.#specificUrl}/getApiExposureData/${id}`);

    getAnsweredQuestionnaireData = (id: number) =>
        this.#httpservice.get<Recipient[]>(`${this.#specificUrl}/getAnsweredQuestionnaireData/${id}`);
    getQuestionnaireDataSubmission = (id: NumberInput) => {
        var x = this.#httpservice.get<QuestionnaireData>(`${this.#specificUrl}/getDataSubmissions/${id}`);
        return x;
        // x.pipe(map(x => {
        //     return {
        //         ...x, contacts: [...x.contacts],
        //         stepsData: x.stepsData.map(y => { return { ...y, questionsData: { ...y.questionsData } } as StepData })
        //     } as QuestionnaireData
        // }));
    }
    // exportDataToEcxel = (id: number) =>
    //     this.#httpservice.get(`${this.#specificUrl}/downloadExcelDataSummary/${id}`,
    //         { responseType: "blob" })
    exportDataToExcel = (id: number, withCompare: boolean, name?: string, date?: Date) => {
        var guid = this.#tostesStore.generateGuid();
        this.#tostesStore.addTost({ guid, message: { en: "Export data to Excel", he: "מייצא נתונים לאקסל.." }, type: TostTypeEnum.LOAD });
        this.#httpservice.get(`${this.#specificUrl}/downloadExcelDataSummary/${id}/${withCompare}`, { responseType: 'blob' })
            .subscribe((blob: Blob) => {
                saveAs(blob, `${name?.slice(0, 100) ?? "data"}${date ? this.#datePipe.transform(date, ' dd/MM/yyyy') : ""}.xlsx`);
                this.#tostesStore.removeTostByGuid(guid);
            },
                (error) => {
                    this.#tostesStore.removeTostByGuid(guid);
                    this.#tostesStore.addTost({ guid, message: { en: "An error occurred while exporting data to Excel", he: "ארעה שגיאה בעת יצוא נתונים לאקסל" }, type: TostTypeEnum.ERROR, seconds: 5 });

                })
    };

    ExporModularQuestionDataSummarytToExcel = (id: number, showComparison: boolean, name?: string, date?: Date) => {
        var guid = this.#tostesStore.generateGuid();
        this.#tostesStore.addTost({ guid, message: { en: "Export data to Excel", he: "מייצא נתונים לאקסל.." }, type: TostTypeEnum.LOAD, seconds: 5 });

        this.#httpservice.get(`${this.#specificUrl}/downloadExcelQuestionDataSummary/${id}/${showComparison}`, { responseType: 'blob' })
            .subscribe((blob: Blob) => {
                saveAs(blob, `${name?.slice(0, 100) ?? "data"}${date ? this.#datePipe.transform(date, ' MM/dd//yyyy') : ""}.xlsx`);
                this.#tostesStore.removeTostByGuid(guid);
            })
    };

    exportDataToPdf(questionnaireId: number, name?: string, recipientsIdes?: number[]) {
        const guid = this.#tostesStore.generateGuid();
        this.#tostesStore.addTost({
            guid,
            message: { en: "Export data to PDF", he: "מייצא נתונים ל-PDF.." },
            type: TostTypeEnum.LOAD
        });

        this.#httpservice.post(`${this.#specificUrl}/downloadPdfDataSummary`, { questionnaireId, recipientsIdes, date: getNowDateToString()}, { responseType: 'blob' })
            .subscribe(
                (blob: Blob) => {
                    const contentType = blob.type;
                    let fileName = `${name?.slice(0, 100) ?? "data"}`;

                    if (contentType === 'application/zip') {
                        fileName += '.zip'; // If the response is a ZIP file
                    } else if (contentType === 'application/pdf') {
                        fileName += '.pdf'; // If the response is a PDF file
                    } else {
                        // If the content type is unexpected, assume it's a PDF for backward compatibility
                        fileName += '.pdf';
                    }
                    // Use FileSaver.js to save the file
                    saveAs(blob, fileName);
                    this.#tostesStore.removeTostByGuid(guid);
                },
                (error) => {
                    this.#tostesStore.removeTostByGuid(guid);
                    this.#tostesStore.addTost({
                        guid,
                        message: { en: "An error occurred while exporting data to PDF", he: "ארעה שגיאה בעת יצוא נתונים ל-PDF" },
                        type: TostTypeEnum.ERROR,
                        seconds: 5
                    });
                }
            );
    }
    changeRecipientsStatus = (questionnaireId: number , recipientId: number) =>
        this.#httpservice.post<{isDone:boolean,recipGuid:string}>(`${this.#specificUrl}/changeRecipientsStatus`,{questionnaireId,recipientId});

    updateApiExposureSelected = (questionnaireId: number, recipientsPayload: any[]) =>
        this.#httpservice.post(`${this.#specificUrl}/updateApiExposureSelected`, { questionnaireId, recipients: recipientsPayload });
}